import React from 'react'
import AssetAllocation from './AssetAllocation'

const App = props => {
  const { contentIntroduction, contentTopLeft, contentBottomRight, contentImageAlt, imageContent } =
    props.content
  return (
    <div>
      <AssetAllocation
        contentIntroduction={contentIntroduction}
        contentTopLeft={contentTopLeft}
        contentBottomRight={contentBottomRight}
        contentImageAlt={contentImageAlt}
        imageContent={imageContent}
      />
    </div>
  )
}

export default App
